module.exports = __webpack_public_path__ + "static/media/moneys.58af5bb2.svg";